import appPageReducer from '@hkm/components/App/domain/reducers';
import images from '@hkm/components/App/imageQueue/domain/reducers';
import attendantAssignmentData from '@hkm/components/Attendant/shared/domain/reducers';
import housekeepingChangeBatchStatus from '@hkm/components/Housekeeping/Batch/domain/reducers';
import housekeepingDashboard from '@hkm/components/Housekeeping/Dashboard/domain/reducers';
import housekeepingDetails from '@hkm/components/Housekeeping/Details/domain/reducers';
import housekeepingStatistics from '@hkm/components/Housekeeping/Statistics/domain/reducers';
import userContext from '@hkm/components/Login/domain/reducers';
import maintenanceDashboard from '@hkm/components/Maintenance/Dashboard/domain/reducers';
import maintenanceDetails from '@hkm/components/Maintenance/Details/domain/reducers';
import oooStatistics from '@hkm/components/Maintenance/Statistics/domain/reducers';
import menu from '@hkm/components/Menu/domain/reducers';
import property from '@hkm/components/Menu/PropertySelector/domain/reducers';
import postingDashboard from '@hkm/components/Posting/Dashboard/domain/reducers';
import postingView from '@hkm/components/Posting/PostingView/domain/reducers';
import postingRoom from '@hkm/components/Posting/shared/domain/reducers';
import maintenanceAttachments from '@hkm/components/shared/Templates/Maintenance/MaintenanceAttachmentsTile/domain/reducers';
import maintenanceCreate from '@hkm/components/shared/Templates/Maintenance/MaintenanceCreateForm/domain/reducers';
import maintenanceUpdateData from '@hkm/components/shared/Templates/Maintenance/shared/domain/reducers';
import taskManagementDashboard from '@hkm/components/TaskManagement/Dashboard/domain/reducers';
import taskManagementRelations from '@hkm/components/TaskManagement/relations/domain/reducers';
import taskManagementTaskDetails from '@hkm/components/TaskManagement/TaskPreview/domain/reducers';
import { combineReducers } from 'redux';

const createRootReducer = () =>
  combineReducers({
    housekeepingDashboard,
    housekeepingStatistics,
    housekeepingDetails,
    housekeepingChangeBatchStatus,
    maintenanceDashboard,
    maintenanceDetails,
    maintenanceUpdateData,
    maintenanceAttachments,
    maintenanceCreate,
    attendantAssignmentData,
    postingDashboard,
    postingRoom,
    postingView,
    property,
    app: appPageReducer,
    userContext,
    menu,
    oooStatistics,
    images,
    tasks: combineReducers({
      dashboard: taskManagementDashboard,
      taskDetails: taskManagementTaskDetails,
      relations: taskManagementRelations
    })
  });

export default createRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.ts